/**
 * Centralized error page route paths.
 * Use for redirectTo, router.navigate(), and guards to avoid drift.
 */
export const ERROR_ROUTES = {
  /** Path for redirectTo (e.g. wildcard) - no leading slash */
  unauthorized: 'error/401',
  /** Path for redirectTo - no leading slash */
  accessdenied: 'error/403',
  notFound: 'error/404',
  serverError: 'error/500',
  ipBanned: 'error/ip-banned',

} as const;

/** Route segments for router.navigate() - e.g. ['/error', '500'] */
export const ERROR_ROUTE_SEGMENTS = {
  badrequest  : ['/error/', '400'] as const,
  unauthorized: ['/error/', '401'] as const,
  accessdenied: ['/error/', '403'] as const,
  notFound:     ['/error/', '404'] as const,
  serverError:  ['/error/', '500'] as const,
  ipBanned:     ['/error/', 'ip-banned'] as const,
  
} as const;

/** First path segments where we DO redirect to error page (only these). Every other route is "content" — no redirect. */
const REDIRECT_FIRST_SEGMENTS = ['auth', 'admin-panel', 'error'] as const;

/**
 * Returns true if the current route is a "content" route (pack, detail, search, gallery, all-assets, home, etc.)
 * where we should NOT redirect to the global error page — the page stays visible and can show errors inline.
 * We only redirect when the user is on /auth, /admin-panel, or /error.
 */
export function isContentRoute(url: string): boolean {
  
  const path = url.split('?')[0].replace(/^\/|\/$/g, '');
  const segments = path ? path.split('/').filter(Boolean) : [];
  if (segments.length === 0) return true; // home
  const first = segments[0].toLowerCase();
  return !REDIRECT_FIRST_SEGMENTS.includes(first as (typeof REDIRECT_FIRST_SEGMENTS)[number]);
}
